import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { useSelector } from 'react-redux';
import '../styles/DetailIndexItem.scss';

function PetIndexItem({ pet: { speciesId, speciesName, nickname, level, quality, creatureDisplayId, isFavorite } }) {
	const pet = useSelector((state) => state.pets[speciesId]);

	// If we've fetched the additional pet data, we can show the media, otherwise
	// we use only have the basic data passed from props.
	// Some pets' creature models don't return images, so we default to the icon
	// if this failure occurs
	return (
		<li className='index-item border'>
			<a href={`https://www.wowhead.com/battle-pet/${speciesId}`} target='_blank' rel='noreferrer' className='index-link'>
				<div className='index-shadow'>
					{isFavorite && <FontAwesomeIcon className='favorite-star' icon={faStar} />}
					{pet && <img src={pet.media.href || pet.media.icon} alt={speciesName} className='index-img pet' />}
					<div className='index-data-details'>
						<p className={`index-name ${quality}`}>{`${nickname || speciesName}`}</p>
						<p className={`index-name ${quality}`}>{`${speciesName} - lvl ${level}`}</p>
					</div>
				</div>
			</a>
		</li>
	);
}

export default PetIndexItem;
